<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">Manage orders</div>
</div>

<div class="page-layout padding-large m-margin-none m-padding m-padding-top-largest">
  <div class="flex margin-bottom">
    <div class="flex-1 flex center">
      <h4>Search Orders</h4>
    </div>
  </div>

  <div class="flex wrap gap">
    <div class="filter-chip" [ngClass]="!orderFilters.ids || !orderFilters.ids.length ? '' : 'selected'">
      @if (orderFilters.ids && orderFilters.ids.length) {
        <div class="flex center hover" (click)="openDialogIdsFilter()">
          <b class="margin-right-smallest">Order ID:</b>
          @for (id of orderFilters.ids; track id; let last = $last) {
            {{ id }}
            @if (!last) {
              ,
            }
          }
        </div>

        <mat-icon class="hover" (click)="cleanFilter('ids')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openDialogIdsFilter()">
          Order ID
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div
      class="filter-chip"
      [ngClass]="!orderFilters.photographers || !orderFilters.photographers.length ? '' : 'selected'"
    >
      @if (orderFilters.photographers && orderFilters.photographers.length) {
        <div class="flex center hover" (click)="openPhotographerFilterModal()">
          <b class="margin-right-smallest">Photographer:</b>

          @for (photographer of orderFilters.photographers; track photographer; let last = $last) {
            {{ photographer.firstName }} {{ photographer.lastName }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('photographers')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openPhotographerFilterModal()">
          Photographer
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!orderFilters.dueDate ? '' : 'selected'">
      @if (orderFilters.dueDate) {
        <div class="flex center hover" (click)="openDueDateFilterModal()">
          <b class="margin-right-smallest">Due Date:</b>

          {{ orderFilters.dueDate.from | date: 'dd-MM-yyyy' }} - {{ orderFilters.dueDate.to | date: 'dd-MM-yyyy' }}
        </div>
        <mat-icon (click)="cleanFilter('dueDate')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openDueDateFilterModal()">
          Due Date
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!orderFilters.creationDate ? '' : 'selected'">
      @if (orderFilters.creationDate) {
        <div class="flex center hover" (click)="openCreationDateFilterModal()">
          <b class="margin-right-smallest">Creation Date:</b>

          {{ orderFilters.creationDate.from | date: 'dd-MM-yyyy' }} -
          {{ orderFilters.creationDate.to | date: 'dd-MM-yyyy' }}
        </div>
        <mat-icon (click)="cleanFilter('creationDate')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openCreationDateFilterModal()">
          Creation Date
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!orderFilters.completionDate ? '' : 'selected'">
      @if (orderFilters.completionDate) {
        <div class="flex center hover" (click)="openCompletionDateFilterModal()">
          <b class="margin-right-smallest">Completion Date:</b>

          {{ orderFilters.completionDate.from | date: 'dd-MM-yyyy' }} -
          {{ orderFilters.completionDate.to | date: 'dd-MM-yyyy' }}
        </div>
        <mat-icon (click)="cleanFilter('completionDate')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openCompletionDateFilterModal()">
          Completion Date
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!orderFilters.statuses || !orderFilters.statuses.length ? '' : 'selected'">
      @if (orderFilters.statuses && orderFilters.statuses.length) {
        <div class="flex center hover" (click)="openStatusFilterModal()">
          <b class="margin-right-smallest">Status:</b>

          @for (status of orderFilters.statuses; track status; let last = $last) {
            {{ status.name }}
            @if (!last) {
              ,
            }
          }
        </div>

        <mat-icon (click)="cleanFilter('statuses')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openStatusFilterModal()">
          Status
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div class="filter-chip" [ngClass]="!orderFilters.orderTypes || !orderFilters.orderTypes.length ? '' : 'selected'">
      @if (orderFilters.orderTypes && orderFilters.orderTypes.length) {
        <div class="flex center hover" (click)="openOrderTypeFilterModal()">
          <b class="margin-right-smallest">Order Type:</b>

          @for (orderType of orderFilters.orderTypes; track orderType; let last = $last) {
            {{ orderType.name }}
            @if (!last) {
              ,
            }
          }
        </div>

        <mat-icon (click)="cleanFilter('orderTypes')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openOrderTypeFilterModal()">
          Order Type
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>
  </div>

  <div class="margin-top-small">
    <div class="flex column end margin-bottom-small">
      <button [routerLink]="['/company/order-view/new/order-detail-info']" class="flex center">
        <mat-icon>add</mat-icon>
        Create custom order
      </button>
    </div>

    @if (orders && orders.items && orders.items.length) {
      <bt-paginator
        [pageNumber]="orders.currentPage"
        [pageSize]="orders.size"
        [totalNumber]="orders.totalCount"
        (clickPage)="pageEvent($event)"
      ></bt-paginator>

      <table class="desktop-only">
        <tr>
          <th>Order</th>
          <th>Photographer</th>
          <th>Order Type</th>
          <th>Creation Date</th>
          <th>Due Date</th>
          <th>Completion Date</th>
          <th>Warehouse</th>
          <th>Products</th>
          <th>Cost</th>
          <th>Status</th>
          <th>Action</th>
        </tr>
        @for (item of orders.items; track item) {
          <tr>
            <td>
              {{ item.id }}
            </td>
            <td>{{ item.photographer.fullName }}</td>
            <td>{{ getOrderTypeLabel(item.orderType) }}</td>
            <td>
              {{ item.creationDate | date: 'dd-MM-yyyy' }}
            </td>
            <td>
              {{ item.dueDate | date: 'dd-MM-yyyy' }}
            </td>
            <td>
              {{ item.completionDate | date: 'dd-MM-yyyy' }}
            </td>
            <td>
              @if (item.isFake) {
                Basicnet
              } @else {
                {{ item.warehouse?.description }}
              }
            </td>

            <td>
              <div class="flex column start">
                @if (item.totalOrdered > 0) {
                  @if (item.totalShipped > 0) {
                    <div class="hover primary" (click)="openShippedSkusModal(item.id)">
                      {{ item.totalShipped }} shipped
                    </div>
                  } @else {
                    <div class="grey">No shipped</div>
                  }

                  <div class="hover" (click)="openOrderedSkusModal(item.id)">
                    <small class="grey">{{ item.totalOrdered }} total</small>
                  </div>
                } @else {
                  <div class="grey">No products</div>
                }
              </div>
            </td>
            <td>
              @if (item.finalCost) {
                <div class="flex column">
                  <span>{{ item.finalCost | currency: 'EUR' : 'symbol' : '1.2-2' }}</span>
                </div>
              }

              <!-- @if (item.status.id != orderStatus.Approved) {
									<span class="grey">{{ item.estimatedCost | currency: 'EUR' : 'symbol' : '1.2-2' }}</span>
									<span class="grey small">Estimated</span>
								} @else {
									<span class="bold">{{ item.finalCost | currency: 'EUR' : 'symbol' : '1.2-2' }}</span>
									<span class="bold small">Confirmed</span>
							} -->
            </td>
            <td>
              <div class="flex column start fix-height">
                @if (item.status.id == orderStatus.Draft) {
                  <div class="radius bg-light-grey primary-dark padding-right-smallest padding-left-smallest">
                    Draft
                  </div>
                  <div class="small nowrap grey">Order is created</div>
                } @else if (item.status.id == orderStatus.Submitted) {
                  <div class="radius bg-primary white padding-right-smallest padding-left-smallest">Submitted</div>
                  <div class="small nowrap grey">
                    {{ item.isFake ? 'Waiting for ready for pickup' : 'Waiting for as400' }}
                  </div>
                } @else if (item.status.id == orderStatus.ReadyForPickup) {
                  <div class="radius bg-primary white padding-right-smallest padding-left-smallest">
                    Ready for pickup
                  </div>
                  <div class="small nowrap grey">Waiting for photographer shots</div>
                } @else if (item.status.id == orderStatus.ShootCompleted) {
                  <div class="radius bg-orange padding-right-smallest padding-left-smallest">Shoot completed</div>
                  <div class="small nowrap grey">Waiting for BasicNet approvation</div>
                } @else if (item.status.id == orderStatus.InProgress) {
                  <div class="radius bg-orange padding-right-smallest padding-left-smallest">In Progress</div>
                  <div class="small nowrap grey">Photographer is shooting right now</div>
                } @else if (item.status.id == orderStatus.Rejected) {
                  <div class="radius bg-red white padding-right-smallest padding-left-smallest">Rejected</div>
                  <div class="small nowrap grey">Waiting for photographer to fix</div>
                } @else if (item.status.id == orderStatus.Approved) {
                  <div class="radius bg-green white padding-right-smallest padding-left-smallest">Approved</div>
                  <div class="small nowrap grey">Order is completed</div>
                }
              </div>
            </td>
            <td>
              <div class="flex center full-width">
                <a
                  [routerLink]="[
                    '/company/order-view/' +
                      item.id +
                      '/order-detail-' +
                      (item.status.id == orderStatus.Draft ? 'info' : 'shots')
                  ]"
                  class="hover flex center primary"
                >
                  <mat-icon class="small margin-right-smallest">visibility</mat-icon>
                  Open
                </a>
                @if (item.status.id == orderStatus.Draft) {
                  <span class="margin-left-small hover flex center red" (click)="removeOrder(item)">
                    <mat-icon class="small">close</mat-icon>
                    Remove
                  </span>
                }
              </div>
            </td>
          </tr>
        }
      </table>

      <div class="mobile-only flex column gap">
        @for (item of orders.items; track item) {
          <div class="border radius padding margin-bottom-small">
            <div class="flex center gap margin-bottom-small">
              <span class="status-chip">
                {{ item.status.name }}
              </span>
              <span class="grey">{{ item.creationDate | date: 'dd-MM-yyyy' }}</span>
            </div>
            <div class="flex column gap margin-bottom-small">
              <div>
                <b>Order:</b>
                {{ item.id }}
              </div>
              <div>
                <b>Photographer:</b>
                {{ item.photographer.firstName }} {{ item.photographer.lastName }}
              </div>
              <div>
                <b>Order Type:</b>
                {{ getOrderTypeLabel(item.orderType) }}
              </div>
              @if (item.dueDate) {
                <div>
                  <b>Due Date:</b>
                  {{ item.dueDate | date: 'dd-MM-yyyy' }}
                </div>
              }
              @if (item.completionDate) {
                <div>
                  <b>Completion Date:</b>
                  {{ item.completionDate | date: 'dd-MM-yyyy' }}
                </div>
              }
            </div>
            <div class="flex column end gap">
              <div class="flex center">
                <a
                  class="hover flex center primary"
                  [routerLink]="['/company/order-view/' + item.id + '/order-detail-info']"
                >
                  <mat-icon class="small margin-right-smallest">visibility</mat-icon>
                  Open
                </a>
                @if (item.status.id == orderStatus.Draft) {
                  <span class="margin-left-small hover flex center red disabled">
                    <mat-icon class="small">close</mat-icon>
                    Remove
                  </span>
                }
              </div>
            </div>
          </div>
        }
      </div>

      <bt-paginator
        [pageNumber]="orders.currentPage"
        [pageSize]="orders.size"
        [totalNumber]="orders.totalCount"
        (clickPage)="pageEvent($event)"
      ></bt-paginator>
    }

    @if (orders.items.length == 0 && !loading) {
      <div class="flex center bg-light-grey padding-largest justify-center">
        <div class="flex column center gap">
          <i class="fa fa-search fa-2xl margin-bottom grey"></i>
          <span>No data found</span>
        </div>
      </div>
    }
  </div>
</div>

@if (loading) {
  <bt-loader></bt-loader>
}
